module.exports = __webpack_public_path__ + "static/media/agent-selected.0e8a4821.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/agent-selected.svg
// module id = 747
// module chunks = 0